<template>
    <v-container fluid>
        <v-row class="pl-12">
            <v-col
                cols="12"
                >
                <v-form ref="form">
                    <v-row>
                        <v-col cols="1" lg="1">
                            <div class="searchBoxLabel">発生日</div>
                        </v-col>
                        <v-col cols="2" xl="1">
                            <v-text-field
                                placeholder="0000-00-00"
                                maxlength="10"
                                inputmode="tel"
                                type="tel"
                                class="width_100"
                                @focus="focusDate(registData.grant_date)"
                                @input="removeStringGrant"
                                :value="formatedDate(registData.grant_date)"
                                @keyup.delete="deleteKeyUpGrantDate($event)"
                                @keyup="registData.grant_date = formatDate(registData.grant_date)"
                                :rules="[rules.string_type,
                                         rules.format_date,
                                         rules.correct_date,
                                         rules.required]"
                                />
                        </v-col>
                        <v-col cols="1" lg="1">
                            <div class="searchBoxLabel pt-1">ポイント種別</div>
                        </v-col>
                        <v-col cols="3">
                            <v-select
                                class="ml-5 width_200"
                                :items="pointType"
                                item-value="code"
                                item-text="code_name"
                                v-model="registData.point_flag"
                                :rules="[rules.required]"
                            />
                        </v-col>
                        <v-col cols="1">
                            <div class="searchBoxLabel">ゴルフ場</div>
                        </v-col>
                        <v-col cols="3">
                            <v-select
                                :items="GolfCourses"
                                item-value="golf_code"
                                item-text="golf_name"
                                v-model="registData.golf_courses_val"
                                :rules="[rules.required]"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        class="flex-nowrap"
                        >
                        <v-col cols="1" lg="1">
                            <div class="searchBoxLabel">ポイント数</div>
                        </v-col>
                        <v-col cols="2" xl="1">
                            <v-text-field
                                class="width_100"
                                v-model="registData.point"
                                placeholder="ポイント"
                                :rules="[rules.required, rules.num]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1" lg="1">
                            <div class="searchBoxLabel">有効期限</div>
                        </v-col>
                        <v-col cols="4" lg="3">
                            <v-row class="">
                                <v-text-field
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    inputmode="tel"
                                    type="tel"
                                    class="width_100"
                                    @focus="focusDate(registData.validFrom)"
                                    @input="registData.validFrom = $event"
                                    :value="formatedDate(registData.validFrom)"
                                    @keyup.delete="deleteKeyUpValidFrom($event)"
                                    @keyup="registData.validFrom = formatDate(registData.validFrom)"
                                    :rules="[rules.string_type,
                                            rules.format_date,
                                            rules.correct_date,
                                            rules.check_some_day,
                                            rules.check_correct_date,
                                            rules.check_valid_from_to]"
                                    :disabled="fromInputDisabled"
                                />
                                <span class="d-flex align-center flex-nowrap mx-4 pb-4">〜</span>
                                <v-text-field
                                    placeholder="0000-00-00"
                                    class="width_100"
                                    maxlength="10"
                                    inputmode="tel"
                                    @focus="focusDate(registData.validTo)"
                                    @input="removeStringTo"
                                    :value="formatedDate(registData.validTo)"
                                    @keyup.delete="deleteKeyUpValidTo($event)"
                                    @keyup="registData.validTo = formatDate(registData.validTo)"
                                    :rules="[rules.string_type,
                                            rules.format_date,
                                            rules.check_correct_date,
                                            rules.check_some_day,
                                            rules.correct_date,
                                            rules.check_valid_to,
                                            rules.check_valid_from_to]"
                                    :disabled="toInputDisabled"
                                />
                            </v-row>
                        </v-col>
                        <v-col cols="1">
                            <div class="searchBoxLabel">詳細内容</div>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="registData.detail"
                                placeholder="詳細内容"
                                maxlength="256"
                                :rules="[rules.required]"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        class="flex-nowrap"
                        >
                        <v-col cols="1" lg="1">
                            <div class="searchBoxLabel">コメント</div>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                class="pr-9"
                                v-model="registData.comment"
                                placeholder="コメント"
                                maxlength="256"
                            />
                        </v-col>
                        <v-btn
                            large
                            color="primary"
                            @click="reference"
                            :disabled="btn[2].isActive">ポイント登録</v-btn>
                    </v-row>
                </v-form>
            </v-col>
            <v-overlay :value="inputError">
                <v-card light width="400px">
                    <v-card-title>会員が選択されていません。</v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="inputError = false">閉じる</v-btn>
                    </v-card-actions>
                </v-card>
            </v-overlay>
        </v-row>
    </v-container>
</template>

<script>
import validater from '@/lib/validater';
import { GET_CODE_LIST } from '@/constants/codelist';
import { utilityMixin } from '@/mixins/utility';

export default {
    props: {
        registData: {
            type: Object
        },
        GolfCourses: {
            type: Array
        },
        pointType: {
            type: Array
        },
        receivedSelected: {
            type: Array
        },
        admin: {
            type: Object,
            default: () => ({
                user_id: '',
                user_div: '',
                golf_code: ''
            })
        },
        btn: {
            type: Array,
            default: () => {}
        }
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            limited_type: [],
            inputError: false,
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                required: value => !!value.length || this.$t('error.validation.required.any'),
                check_correct_date: value => this.checkstartDate(value) || this.$t('error.validation.date.discrepancy'),
                check_some_day: value => this.checkSomeDate(value) || this.$t('error.validation.time.some'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct'),
                num: value => validater.checkNum(value) || this.$t('error.validation.num'),
                check_valid_to: value => this.checkValidTo(value) || this.$t('error.validation.required.any'),
                check_valid_from_to: value => this.checkValidFromTo(value) || this.$t('error.validation.required.any')
            }
        };
    },
    async created () {
        this.limited_type = await this.getCodeList('point_flag');
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        },
        fromInputDisabled () {
            return this.registData.point_flag === '1' || this.registData.point_flag === '2';
        },
        toInputDisabled () {
            return this.registData.point_flag === '1';
        }
    },
    watch: {
        'registData.point_flag': function (val, oldval) {
            if (val === '1') {
                this.$refs.form.resetValidation();
                this.registData.validFrom = '';
                this.registData.validTo = '';
            } else if (val === '2') {
                this.$refs.form.resetValidation();
                this.registData.validFrom = '';
            }
        },
        'registData.point': function (val) {
            this.registData.point = val.replace(/[^\d-]/g, '');
        }
    },
    methods: {
        reference () {
            if (this.$refs.form.validate()) {
                if (this.receivedSelected.length === 0) {
                    this.inputError = true;
                } else {
                    this.$emit('event');
                }
            }
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpGrantDate (event) {
            this.registData.grant_date = this.formatDate(this.registData.grant_date);
            this.registData.grant_date = this.deleteKeyDelete(event);
        },
        deleteKeyUpValidFrom (event) {
            this.registData.validFrom = this.formatDate(this.registData.validFrom);
            this.registData.validFrom = this.deleteKeyDelete(event);
        },
        deleteKeyUpValidTo (event) {
            this.registData.validTo = this.formatDate(this.registData.validTo);
            this.registData.validTo = this.deleteKeyDelete(event);
        },
        /** --------------------------------------------
        * 発生日に文字列を削除する
        * -------------------------------------------- */
        removeStringGrant (val) {
            this.registData.grant_date = val.replace(/[^\d-]/g, '');
        },
        /** --------------------------------------------
        * 期間限定Fromに文字列を削除する
        * -------------------------------------------- */
        removeStringFrom (val) {
            this.registData.validFrom = val.replace(/[^\d-]/g, '');
        },
        /** --------------------------------------------
        * 期間限定Toに文字列を削除する
        * -------------------------------------------- */
        removeStringTo (val) {
            this.registData.validTo = val.replace(/[^\d-]/g, '');
        },
        /** --------------------------------------------
        * 期間限定の場合開始日と終了日が同日になっていないか
        * -------------------------------------------- */
        checkSomeDate () {
            if (this.registData.point_flag === '2' && !this.registData.validFrom) {
                return true;
            } else if (this.registData.point_flag === '3' && this.registData.validTo.length === 10) {
                const enddate = Number(this.registData.validTo.replace(/-/g, ''));
                const startdate = Number(this.registData.validFrom.replace(/-/g, ''));
                if (startdate === enddate) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        /** --------------------------------------------
        * 期間限定の場合終了日が開始日より前日になっていないか
        * -------------------------------------------- */
        checkstartDate () {
            if (this.registData.point_flag === '2' && !this.registData.validFrom) {
                return true;
            } else if (this.registData.point_flag === '3' && this.registData.validTo.length === 10) {
                const enddate = Number(this.registData.validTo.replace(/-/g, ''));
                const startdate = Number(this.registData.validFrom.replace(/-/g, ''));
                if (startdate > enddate) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        /** --------------------------------------------
        * 期限付きの場合Toを必須にする
        * -------------------------------------------- */
        checkValidTo (value) {
            if (this.registData.point_flag === '2' && !value) {
                return false;
            } else {
                return true;
            }
        },
        /** --------------------------------------------
        * 期間限定の場合、FromとToを必須にする
        * -------------------------------------------- */
        checkValidFromTo (value) {
            if (this.registData.point_flag === '3' && !value) {
                return false;
            } else {
                return true;
            }
        },
        /** --------------------------------------------
        * limited_pointセレクトボックスをマスタから取得
        * -------------------------------------------- */
        getCodeList (keyname) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: keyname,
                    default_display: 0
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        },
        ValidReset () {
            this.$refs.form.resetValidation();
        }
    }
};
</script>

<style scoped>

.searchBoxLabel{
    font-size: 14px;
    white-space: nowrap;
}
.row{
    flex-wrap: nowrap;
    align-items: baseline;
}

.col-3{
    padding: 0 50px 0 18px;
}

.v-input--selection-controls{
    margin-top: 0;
    padding-top: 0;
}

.v-text-field{
    margin-top: 0;
    padding-top: 0;
}
.v-text-field ::v-deep input{
    padding: 0;
}
.width_100{
    width: 100px;
}
.width_120{
    width: 120px;
}
.width_200{
    width: 200px;
}

.width_100.v-input{
    flex: initial;
}
</style>
